import { i18n } from '../../../../app/javascript/packs/localized-i18n'

if (typeof LOCALE !== 'undefined') {
  i18n.locale = LOCALE
  i18n.defaultLocale = DEFAULT_LOCALE
}
